export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';
export const SET_MODAL_CONTENT = 'SET_MODAL_CONTENT';
export const SET_MODAL_FOOTER_HEIGHT = 'SET_MODAL_FOOTER_HEIGHT';
export const SET_MODAL_HEADER_HEIGHT = 'SET_MODAL_HEADER_HEIGHT';

export const showModal = (selectedModalName: string) => ({
  type: SHOW_MODAL,
  payload: selectedModalName,
});

export const hideModal = () => ({
  type: HIDE_MODAL,
});

export const setModalContent = (pageModel: any) => ({
  type: SET_MODAL_CONTENT,
  payload: pageModel,
});

export const setModalFooterHeight = (height: number) => ({
  type: SET_MODAL_FOOTER_HEIGHT,
  payload: height,
});

export const setModalHeaderHeight = (height: number) => ({
  type: SET_MODAL_HEADER_HEIGHT,
  payload: height,
});
